import React, { useState } from 'react';
import RemoveConfirmationModal from '../RemoveConfirmation/RemoveConfirmationModal';
import useNotification from '../../Hooks/useNotification.hook';
import { useAppContext } from '../../Services/AppContext';
import { Theme } from '../../Enums/Theme.enum';
import { useFormContext } from '../Form/FormContext';
import Button from './Button';

interface SubmitButtonWithConfirmationProps {
	title?: string;
	flashMessage?: string;
	confirmationText?: string;
	confirmationTitle?: string;
	customButtons?: React.reactNode | React.reactNode[];
	onSubmit: (values: object) => any;
	disabled?: boolean;
}

export default function SubmitButtonWithConfirmation(
	props: SubmitButtonWithConfirmationProps,
) {
	const {
		onSubmit,
		disabled,
		flashMessage,
		title,
		confirmationText,
		confirmationTitle,
		customButtons,
	} = props;
	const [confirmationOpen, setConfirmationOpen] = useState(false);
	const { showNotificationSuccess } = useNotification();
	const { translation } = useAppContext();
	const { handleSubmit } = useFormContext();

	const handlePress = () => {
		setConfirmationOpen(true);
	};

	const handleConfirm = () => {
		if (!disabled) {
			if (typeof onSubmit === 'function') {
				handleSubmit(onSubmit)();
			}
		}
		showNotificationSuccess({
			content: translation[flashMessage],
		});
		setConfirmationOpen(false);
	};

	return (
		<>
			<Button onClick={handlePress} title={title} theme={Theme.GREEN} />
			{confirmationOpen && (
				<RemoveConfirmationModal
					opened
					onClose={() => setConfirmationOpen(false)}
					onConfirm={handleConfirm}
					confirmationText={confirmationText}
					confirmationTitle={confirmationTitle}
					customButtons={customButtons}
					showAbort={false}
				/>
			)}
		</>
	);
}
